// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3iqad","title":"Info_title__1H_Z8","links":"Info_links__1CsAV","link":"Info_link__2nEoW","logo":"Info_logo__3x-Mi"};